module.exports = __webpack_public_path__ + "media/images/icons/activity-icon-e7e141401bbb05c12bec669233f81369.svg";